import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { LINE_ITEM_CART_DISCOUNT } from '../../util/types';

import css from './OrderBreakdown.module.css';

/**
 * CL-DISC-01 §F, requirement 3's third row: the dedicated discount.
 *
 * A SEPARATE row from `LineItemOfferAdjustmentMaybe` on purpose — AC-data-1 requires the
 * negotiation and the discount never be netted into one figure, because they answer different
 * questions ("what did the buyer and seller agree the goods are worth" vs. "what did the seller
 * additionally knock off"). Same shape as `LineItemPickupFeeMaybe`: find the non-reversal line by
 * code, render nothing when absent (DISC AC3). No role prop — `OrderBreakdown.js` has already
 * filtered `lineItems` to the viewer's own role before this ever sees them, and the discount
 * line's `includeFor: ['customer', 'provider']` (offerLineItems.js, cartLineItems.js) survives
 * that filter for both, so the seller who absorbs the discount sees it too (D-16).
 *
 * D13 (CL-NEG-01 post-merge, 2026-09-09) removed the dedicated discount's ENTRY POINTS — no
 * discount field in `SellerOfferModal`/`OfferCounterModal` any more — but NOT this component. A
 * transaction created before D13 still carries a real `line-item/cart-discount` line, and this
 * row is what keeps rendering it. Deliberately parked for a future standalone discount feature —
 * do not delete it as dead code.
 *
 * @component
 * @param {Object} props
 * @param {Array<propTypes.lineItem>} props.lineItems
 * @param {Object} props.intl
 * @returns {JSX.Element|null}
 */
const LineItemDiscountMaybe = props => {
  const { lineItems, intl } = props;

  const discountLine = (lineItems || []).find(
    li => li.code === LINE_ITEM_CART_DISCOUNT && !li.reversal
  );

  return discountLine ? (
    <div className={css.lineItem}>
      <span className={css.itemLabel}>
        <FormattedMessage id="OrderBreakdown.cartDiscount" />
      </span>
      <span className={css.itemValue}>{formatMoney(intl, discountLine.lineTotal)}</span>
    </div>
  ) : null;
};

export default LineItemDiscountMaybe;
